"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = Overlay;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var sc = _interopRequireWildcard(require("./Overlay.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  /** Will call an onClose handler when clicked on (outside of the Panel) */
  hasOutsideClick: _propTypes["default"].bool,

  /** Callback for click event */
  onClose: _propTypes["default"].func,

  /** The z-index of the Panel Overlay */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  hasOutsideClick: true,
  onClose: null,
  zIndex: null
};

function Overlay(props) {
  var onClose = props.onClose,
      hasOutsideClick = props.hasOutsideClick,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["onClose", "hasOutsideClick"]);
  var I18n = (0, _useI18n["default"])();

  var handleClick = function handleClick() {
    if (hasOutsideClick) {
      onClose();
    }
  };

  var overlayProps = _objectSpread(_objectSpread({
    a11yText: I18n.t("close")
  }, moreProps), {}, {
    children: "",
    "data-pka-anchor": "side-panel.overlay",
    onClick: handleClick
  });

  return /*#__PURE__*/_react["default"].createElement(sc.Overlay, overlayProps);
}

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
Overlay.displayName = "Panel.Overlay";
//# sourceMappingURL=Overlay.js.map